import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusUpcomingPayment00Table: GenericTableSchemaInterface = {
  id: "fms-plus-upcoming-payment-00",
  name: "FMS+ Upcoming Payment 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Due workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "Account Balance",
      variable: VarKey.LeaseBalance
    },
    c05: {
      name: "7 days before payment is due SMS"
    },
    c06: {
      name: "5 days before payment is due SMS"
    },
    c07: {
      name: "3 days before payment is due SMS"
    },
    c08: {
      name: "2 days before payment is due SMS"
    },
    c09: {
      name: "1 day before payment is due SMS"
    },
    c10: {
      name: "Day that payment is due SMS"
    },
    c11: {
      name: "7 days before payment is due Email"
    },
    c12: {
      name: "5 days before payment is due Email"
    },
    c13: {
      name: "3 days before payment is due Email"
    },
    c14: {
      name: "2 days before payment is due Email"
    },
    c15: {
      name: "1 day before payment is due Email"
    },
    c16: {
      name: "Day that payment is due Email"
    }
  }
};
